export default "assets/images/icons/wine-robe-ccbd1aff.svg";